import s from './Brand.module.css';

/** Logo Siraj (écran, étincelle et curseur sur carré ambre) + nom du produit. */
export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <span className={s.brand}>
      <svg width="34" height="34" viewBox="0 0 32 32" aria-hidden="true" className={s.logo}>
        <rect width="32" height="32" rx="8" fill="#F5B335" />
        <g fill="#0F1623" stroke="#0F1623" strokeLinecap="round" strokeLinejoin="round">
          <path
            d="M20.1 20.3H8.1a1.9 1.9 0 0 1-1.9-1.9v-7.8a1.9 1.9 0 0 1 1.9-1.9h15.7a1.9 1.9 0 0 1 1.9 1.9v8"
            fill="none"
            strokeWidth="1.9"
          />
          <path d="M12.8 22h7l1 2.8H10.6z" strokeWidth=".5" />
          <path
            d="M20.3 11.2Q20.8 13.5 23 14 20.8 14.5 20.3 16.8 19.8 14.5 17.6 14 19.8 13.5 20.3 11.2z"
            strokeWidth=".4"
          />
          <path d="M21.4 17.4l.4 4 .9-.9 1.2 1.8.5-.3-1-1.9 1.4-.5z" strokeWidth=".7" />
        </g>
      </svg>
      {!compact && (
        <span className={s.name}>
          Siraj <span className={s.accent}>Console</span>
        </span>
      )}
    </span>
  );
}
